<template>
    <v-container max-width="100%" style="margin-top: 2%">

        <merus-data-table :headers="headers" :items="categorias" :loading="loading"
            :loading-text="$t('ticketCategory.loading')" @update:displayedItems="displayedItemsForExport = $event"

 cod-tabela="CATEGORIASTICKETS" @update:headers="headers = $event">
            <template v-slot:toolbar>
                <cadastro-toolbar :title="$t('ticketCategory.title')" :token="token"
                    :items="displayedItemsForExport !== null ? displayedItemsForExport : categorias"
                    :csv-title="$t('ticketCategory.title')" :csv-headers="headers"
                    :pdf-title="$t('ticketCategory.title')" :pdf-headers="headers" :pdf-filename="$t('ticketCategory.title')"
                    hide-search>
                    <template v-slot:add v-if="canInsert">
                        <v-btn color="primary" dark small class="mb-2" @click="dialog = true" fab>
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                        <v-dialog v-model="dialog" max-width="800px" persistent>
                            <v-card>
                                <v-card-title class="justify-center pa-6">
                                    <v-icon left color="primary" class="mr-3">{{ formIcon }}</v-icon>
                                    <span class="headline">{{ formTitle }}</span>
                                </v-card-title>
                                <v-card-text class="pa-6">
                                    <v-form ref="form" v-model="formValidado">
                                        <v-row>
                                            <v-col cols="12">
                                                <v-card class="pa-4 mb-4" outlined>
                                                    <v-card-title class="text-h6 pa-0 mb-3">
                                                        {{ $t('ticketCategory.name') }}
                                                    </v-card-title>
                                                    <v-divider class="mb-3"></v-divider>
                                                    <v-text-field v-model="editedItem.nome_categoria"
                                                        :label="$t('ticketCategory.name')"
                                                        :rules="[(v) => !!v || $t('rules.messageName')]" dense outlined
                                                        hide-details />
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-card class="pa-4 mb-4" outlined>
                                                    <v-card-title class="text-h6 pa-0 mb-3">
                                                        {{ $t('ticketCategory.description') }}
                                                    </v-card-title>
                                                    <v-divider class="mb-3"></v-divider>
                                                    <v-text-field v-model="editedItem.descricao_categoria"
                                                        :label="$t('ticketCategory.description')"
                                                        :rules="[(v) => !!v || $t('rules.descriptionIsRequired')]" dense
                                                        outlined hide-details />
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-card class="pa-4 mb-4" outlined>
                                                    <v-card-title class="text-h6 pa-0 mb-3">
                                                        {{ $t('ticketCategory.profileAccess') }}
                                                    </v-card-title>
                                                    <v-divider class="mb-3"></v-divider>
                                                    <multipla-escolha :items="perfis" ref="perfisSelect"
                                                        text="descricao_tipo_usuario" value="id_perfil_usuario"
                                                        :label="$t('nav.profiles')" can-toggle-all
                                                        v-bind:selected-items.sync="perfisSelected"
                                                        @error="showErrorSelect"
                                                        :rules="[perfisRules]"></multipla-escolha>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </v-card-text>
                                <v-card-actions class="justify-end">
                                    <v-btn color="primary" dark @click="save" :loading="loadingCategorias">
                                        <v-icon left>mdi-content-save</v-icon>{{ $t('button.save') }}
                                    </v-btn>
                                    <v-btn color="primary" dark @click="close" :loading="loadingCategorias">
                                        <v-icon left>mdi-close</v-icon>{{ $t('button.close') }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </template>
                </cadastro-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" color="green" @click="editItem(item)" :disabled="!canEdit">mdi-pencil</v-icon>
            </template>
        </merus-data-table>
    </v-container>
</template>

<script>

import EventBus from "@/utils/eventBus";
import MerusDataTable from "../Tables/MerusDataTable.vue";
import CadastroToolbar from "../Toolbars/CadastroToolbar.vue";
import apiController from "@/utils/apiController";
import MultiplaEscolha from "../Selects/MultiplaEscolha.vue";
import translateDbField from "@/utils/translateDbField";

export default {
    name: 'CRUDCategoriasTickets',
    components: {
        MerusDataTable,
        CadastroToolbar,
        MultiplaEscolha
    },
    data: () => ({
    headers: [],
        displayedItemsForExport: null,
        user: null,
        token: null,
        dialog: false,
        categorias: [],
        loading: false,
        formValidado: false,
        editedIndex: -1,
        editedItem: {
            descricao_categoria: '',
            nome_categoria: '',
        },
        defaultItem: {
            descricao_categoria: '',
            nome_categoria: '',
        },
        loadingCategorias: false,
        operacao: 0,
        perfis: [],
        perfisSelected: [],
        recursos: [],
        canInsert: false,
        canEdit: false,
        canDelete: false,
    }),
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.populaRecursos();
    },
    computed: {
        perfisRules() {
            return (v) => (v && v.length > 0) || this.$t('rules.profilesAreRequired');
        },
    formTitle() {
            return this.editedIndex === -1 ? this.$t('ticket.newTicket') : this.$tc('ticket.self', 1);
        },
        formIcon() {
            return this.editedIndex === -1 ? 'mdi-plus-circle' : 'mdi-pencil';
        }
    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        }
    },
    methods: {

        populaRecursos() {
            if (this.user.is_superadmin === 1) {
                apiController.request(apiController.endpoints.getallRecursos, {
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.canEdit = true;
                        this.canInsert = true;
                        this.canDelete = true;
                        this.initialize();
                    },
                });
            } else {
                apiController.request(apiController.endpoints.getRecursosusuario, {
                    params: { id: this.user.id_usuario },
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updatecategoria");
                        this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/insertcategoriaticket");
                        this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deletecategoriaticket");
                        this.initialize();
                    },
                });
            }
        },
        initialize() {
            this.PopulaCategorias();
            this.PopulaPerfis();
        },
        PopulaCategorias() {
            apiController.request(apiController.endpoints.getallCategorias, {
              onSuccess: (response) => {
                this.categorias = response.data.map((categoria) => {
                  const translated = translateDbField(
                    categoria.translation_key,
                    categoria.descricao_categoria
                  );
                  return {
                    ...categoria,
                    descricao_categoria: translated
                  };
                });
              },
            });
        },
        PopulaPerfis() {
            apiController.request(apiController.endpoints.getallPerfisusuarios, {
                silent: true,
                onSuccess: (response) => {
                    this.perfis = response.data;
                },
            });
        },
        updateTable(response) {
            if (response.data.erro) {
            if (this.operacao == 0) {
                EventBus.$emit('show-alert', { mensagem: "Erro na inclusão da Categoria: " +  response.data.mensagem, tipo: 'error' });
            }
            } else {
            if (this.operacao == 0) {
                EventBus.$emit('show-alert', { mensagem: "Categoria incluída com sucesso", tipo: 'success' });
            }
            }
            if (this.operacao !== 2) {
                this.close();
            }
            this.initialize();
        },
        save() {
            if (!this.formValidado) {
                EventBus.$emit('show-alert', { mensagem: "Por favor, corrija os erros no formulário antes de salvar", tipo: 'warning' });
                return;
            }

            if (!this.editedItem.descricao_categoria) {
                EventBus.$emit('show-alert', { mensagem: "Por favor, digite um nome para a categoria", tipo: 'warning' });
                return;
            }

            if (this.editedIndex === -1) {
                this.operacao = 0;
                const dadosParaEnviar = {
                    ...this.editedItem,
                    perfis_selecionados: this.perfisSelected
                };
                apiController.request(apiController.endpoints.insertCategoriaticket, {
                    data: dadosParaEnviar,
                    onSuccess: (response) => {
                        this.updateTable(response);
                    },
                });
            } else {
                this.operacao = 1;
                const dadosParaEnviar = {
                    ...this.editedItem,
                    perfis_selecionados: this.perfisSelected
                };
                apiController.request(apiController.endpoints.updateCategoria, {
                    data: dadosParaEnviar,
                    onSuccess: (response) => {
                        this.updateTable(response);
                    },
                });
            }
        },
        editItem(item) {
            this.editedIndex = this.categorias.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;

            this.carregarPerfisCategoria(item.id_categoria);
        },
        carregarPerfisCategoria(id_categoria) {
            apiController.request(apiController.endpoints.getAcessoscategoria, {
                params: { id: id_categoria },
                onSuccess: (response) => {
                    if (!response.data.erro) {
                        this.perfisSelected = response.data.perfis;
                        this.$nextTick(() => {
                            if (this.$refs.perfisSelect) {
                                this.$refs.perfisSelect.setData(this.perfisSelected);
                            }
                        });
                    }
                },
            });
        },
        close() {
            this.dialog = false;
            this.$refs.form.resetValidation();
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
            });
            this.$refs.perfisSelect.resetData();
            this.editedIndex = -1;
        },
        showErrorSelect(e) {
            this.tipoAlerta = "error";
            this.mensagemAlerta = e;
            this.showAlert = true;
        }
    }
}   
</script>